import { render, staticRenderFns } from "./_CreateOrEdit.vue?vue&type=template&id=47f78709&scoped=true&"
import script from "./_CreateOrEdit.vue?vue&type=script&lang=js&"
export * from "./_CreateOrEdit.vue?vue&type=script&lang=js&"
import style0 from "./_CreateOrEdit.vue?vue&type=style&index=0&id=47f78709&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f78709",
  null
  
)

export default component.exports